export enum BANK_PERMISSIONS {
  BANK_VIEW = 'PAYMENT_BANKVIEW',
  BANK_WRITE = 'PAYMENT_BANKWRITE',
  PAYMENT_SETTINGS_VIEW = 'PAYMENT_SETTINGSVIEW',
}
